module.exports = __webpack_public_path__ + "img/italic.0554e6f3.svg";